import React from 'react'
import styled from 'styled-components'
import { LKButton } from 'loankeeper-common/components'
import colors from 'loankeeper-common/components/colors'

import LKModal, { LKModalContainer, actions as LKModalActions } from './LKModal'
import LKGrid from './LKGrid'

export const openActiveNotesModal = (modalInstanceName) => LKModalActions.open({ name: modalInstanceName })

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  .notes__header {
    padding: 12px 0;
    font-weight: bold;
    background: ${colors.red};
    color: #fff;
    font-size: 1.2em;
    text-align: center;
  }
`

export const ActiveNotesModal = LKModalContainer()(
  ({ modalInstanceName, isFetching, heading, onRefresh, onClose, title, notes, gridConfig }) => (
    <LKModal
      name={modalInstanceName}
      heading={heading}
      loading={isFetching}
      onClose={onClose}
      size="medium"
      footer={<LKModal.Footer sideActions={<LKButton alias="refresh" onClick={onRefresh} disabled={isFetching} />} />}
    >
      <Wrapper>
        <div className="notes__header">{title}</div>
        <LKGrid rowData={notes} {...gridConfig} />
      </Wrapper>
    </LKModal>
  ),
)
